export enum LoanApplicationReasonEnum {
  BRIDGE_FINANCING_SHORTER_PAYMENT_TIME = "bridge_financing_shorter_payment_time",
  PROJECT = "project",
  PURCHASE_REAL_ESTATE = "purchase_real_estate",
  REFINANCE_CURRENT_PROPERTY_LOAN = "refinance_current_property_loan",
  REAL_ESTATE_NEW_CONSTRUCTION_OR_RENOVATION = "real_estate_new_construction_or_renovation",
  OTHER_PROPERTY_FINANCE = "other_property_finance",

  REAL_ESTATE_FINANCING = "real_estate_financing",

  OBJECT_FINANCING = "object_financing",
  SUPPLY = "supply",
  OTHER_EXPANSION = "other_expansion",
  OTHER_LIQUIDITY_NEEDS = "other_liquidity_needs",
  DEBT = "debt",
  INVOICE_FINANCING = "invoice_financing",
  PURCHASE = "purchase",
  OTHER = "other",
}

export enum LoanApplicationStateEnum {
  DRAFT = "DRAFT",
  CREATED = "CREATED",
  REJECTED = "REJECTED",
  ADVICE = "ADVICE",
  OPEN_FOR_BIDS = "OPEN_FOR_BIDS",
  NO_BIDS_RECEIVED = "NO_BIDS_RECEIVED",
  BIDS_REJECTED_BY_CUSTOMER = "BIDS_REJECTED_BY_CUSTOMER",
  BID_SELECTED = "BID_SELECTED",
  PAYOUT_RECEIVED_BY_CUSTOMER = "PAYOUT_RECEIVED_BY_CUSTOMER",
}
